export default "__VITE_ASSET__BDFY4Ipd__"